import { useContext, useEffect } from "react";

import { Grid } from "@material-ui/core";
import Loading from "../../../components/basics/Loading";
import HeaderModule from "../../../components/header/HeaderModule";
import { PainelContainer } from "./styles/Prescricao";
import {
  PrescricaoContext,
  PrescricaoContextProvider,
} from "./contexts/PrescricaoContext";
import { AccordionPrescricaoGerais } from "./children/AccordionPrescricaoGerais";
import { AccordionPrescricaoProduto } from "./children/AccordionPrescricaoProduto";
import { AccordionPrescricaoCadastroLente } from "./children/AccordionPrescricaoCadastroLente";
import { AccordionPrescricaoCadastroAro } from "./children/AccordionPrescricaoCadastroAro";
import { AccordionPrescricaoGeral } from "./children/AccordionPrescricaoGeral";
import usePrescricaoController from "./controllers/PrescricaoController";
import Btn from "../../../components/buttons/Btn";

const Page = ({ location }) => {
  const { loading } = useContext(PrescricaoContext);

  const { handleBackSubmit, handleAddPrescricao, handleAutoPrescricao } =
    usePrescricaoController();

  useEffect(() => {
    if (location?.state?.item) {
      handleAutoPrescricao(location.state.item);
    }
  }, [location?.state?.item, handleAutoPrescricao]);

  return (
    <>
      <HeaderModule title="CADASTRO DE RECEITAS" textcolor="black" />

      <Loading open={loading} />

      <PainelContainer maxWidth="xl">
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <AccordionPrescricaoGerais />
          </Grid>
          <Grid item xs={12}>
            <AccordionPrescricaoProduto />
          </Grid>
          <Grid item xs={12}>
            <AccordionPrescricaoCadastroLente />
          </Grid>
          <Grid item xs={12}>
            <AccordionPrescricaoCadastroAro />
          </Grid>
          <Grid item xs={12}>
            <AccordionPrescricaoGeral />
          </Grid>
        </Grid>
        <Grid
          item
          container
          justifyContent="flex-end"
          style={{ marginTop: 20, marginBottom: 20 }}
          spacing={1}
        >
          <Grid item>
            <Btn label="Voltar" bgcolor="tertiary" onClick={handleBackSubmit} />
          </Grid>
          <Grid item flex={1}>
            <Btn label="Cancelar" bgcolor="tertiary" />
          </Grid>
          <Grid item>
            <Btn label="Salvar" onClick={() => handleAddPrescricao(false)} />
          </Grid>
          <Grid item>
            <Btn
              label="Salvar e Novo"
              onClick={() => handleAddPrescricao(true)}
            />
          </Grid>
        </Grid>
      </PainelContainer>
    </>
  );
};

const PrescricaoCadastro = ({ ...props }) => (
  <PrescricaoContextProvider>
    <Page {...props} />
  </PrescricaoContextProvider>
);

export { PrescricaoCadastro };
